export default __webpack_public_path__ + "static/media/fasting-burn.2a4a7067.svg";